<template>
  <li class="product-item">

    <div class="product-img">
      <div class="responsive-box">
        <div class="logo">
        </div>
        <div class="art" :style="imgStyle">
        </div>
      </div>
    </div>

    <div class="product-info">

      <div class="product-name">
        <div class="product-head">
            <a :href="productURL">{{product.nameRU}}</a>
        </div>
      </div><!-- product-head -->
      <div class="product-name">
        <span>
            {{product.nameIT}}
        </span>
      </div>
      <div class="product-name">
        <span>
            {{product.nameEN}}
        </span>
      </div>

      <div class="product-mpn">
        <span class="label-item">Артикул: </span>
        <a :href="productURL"><span class="mpn">{{product.mpn}}</span></a>
      </div>

      <div class="product-price">
        <span class="label-item">Цена: </span>
        <span class="price"> &euro; {{parseFloat(product.price)}}</span>
      </div>
<!-- 
Ширина, мм: 
Глубина, мм: 
Высота, мм: 
Диаметр, мм: 
Толщина, мм: 
-->
      <div v-if="product.width" class="product-prop">
        <span class="prop-label">Ширина, мм: </span>
        <span class="prop-data">{{product.width}}</span>
      </div>
      <div v-if="product.depth" class="product-prop">
        <span class="prop-label">Глубина, мм: </span>
        <span class="prop-data">{{product.depth}}</span>
      </div>
      <div v-if="product.height" class="product-prop">
        <span class="prop-label">Высота, мм: </span>
        <span class="prop-data">{{product.height}}</span>
      </div>
      <div v-if="product.diam" class="product-prop">
        <span class="prop-label">Диаметр, мм: </span>
        <span class="prop-data">{{product.diam}}</span>
      </div>
      <div v-if="product.thick" class="product-prop">
        <span class="prop-label">Толщина, мм: </span>
        <span class="prop-data">{{product.thick}}</span>
      </div>

    </div><!-- product-info -->

  </li><!-- product-item -->
</template>

<script>

export default {
  name: 'ProductItemDetail',
  props: ['product'],
  methods: {

    requestFinish: function() {
      this.$parent.$emit('finish', this.product);
    } //requestFinish

  }, //methods

  computed: {

    productURL: function() {
      return 'http://www.las.ru' + this.product.url;
    }, //productURL

    imgStyle: function() {
      return 'background: url(' + this.product.svg + ')' +
             'no-repeat center top; background-size: ' + this.product.scale + '% auto;';
    }, //imgStyle

    priceReduced: function() {
      return this.product.price * 0.9;
    } //priceReduced

  } //computed
} //default
</script>

<style scoped>
  .product-item {
    border-bottom: 1px dotted gray;
    padding-bottom: 10px;
    padding-top: 20px;
  }

  .product-item:last-child {
    border-bottom: none;
  }

  .product-info {
    margin-left: 5%;
    margin-bottom: 20px;
    font-size: 0;
    width: 50%;
    display: inline-block;
    vertical-align: top;
    letter-spacing: 0;
  }
  .product-name {
    font-weight: 600;
    color: #888;
    font-size: 18px;
    line-height: 1.3em;
    text-align: left;
    margin: 5px 0 5px 0;
  }
  .product-head, 
  .product-head a {
    color: #444;
    font-weight: bold;
    font-size: 1.1em;
    margin: 0px 0 20px 0;
  }
  .product-head a:hover {
    color: rgba(240, 73, 88, 1);
  }

  .product-img {
    width: 43%;
    display: inline-block;
  }

  .product-img .logo {
      padding-top: 120%;
      display: block;
      text-align: left;
      width: 50%;
      color: #fff;
  }
  .product-img .logo img {
      width: 50%;
  }

  .product-mpn,
  .product-price  {
    text-align: left;
    display: inline-block;
    width: 40%;
    font-size: 16px;
    margin: 10px 0 16px 0;
  }
  .product-price {
    width: 60%;
  }
  .product-mpn a .mpn {
    font-size: 1.2em;
    font-weight: bold;
    text-decoration: none;
    border-bottom: 2px dashed rgba(240, 73, 88, 0.5);
  }
  .product-mpn a .mpn:hover {
    border-bottom: 2px solid rgba(240, 73, 88, 1);
  }
  .product-price .price {
    font-size: 1.2em;
    font-weight: bold;
  }

  .product-prop {
    text-align: left;
    display: inline-block;
    width: 100%;
    font-size: 14px;
  }

  .label-item,
  .prop-label {
    font-weight: 600;
    color: #667B82;
  }
  .prop-data {
    font-size: 1.2em;
    font-weight: bold;
    color: rgb(0, 0, 0);
  }

  @media (min-width: 480px) {
    .product-img {
      width: 40%;
      display: inline-block;
    }
  }
  @media (min-width: 640px) {
    .product-img {
      width: 30%;
      display: inline-block;
    }
  }
  @media (min-width: 960px) {
    .product-img {
      width: 18%;
      display: inline-block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/ProductListItemDetail.vue